"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTeamOrganisationsQuerySchema = exports.ImportAppleAuthBodySchema = exports.CreateHostedAppleAuthBodySchema = exports.CreateTeamAppleAuthBodySchema = exports.ListTeamOrganisationsResponseSchema = exports.ImportAppleAuthResponseSchema = exports.CreateHostedAppleAuthResponseSchema = exports.CreateTeamAppleAuthResponseSchema = exports.AppleOrganisationInfoResponseSchema = exports.AppleOrganisationInfoSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("../common");
const CreateAppleAuthFields = {
    redirectUri: typebox_1.Type.Optional(typebox_1.Type.String({ format: "uri" })),
    authCode: typebox_1.Type.String(),
};
const ImportAppleAuthFields = {
    redirectUri: typebox_1.Type.Optional(typebox_1.Type.String({ format: "uri" })),
    refreshToken: typebox_1.Type.String(),
    // Default status for the orgInfo which are found when refreshing with this token
    defaultStatus: common_1.AppleOrganisationInfoStatusSchema,
    // A list of team ids which will immediately be given access to ALL the orgs found (potentially dangerous if defaultStatus is not CLIENT or DISABLED)
    teamIds: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
};
/**
 * Response
 */
const AppleOrganisationInfoFields = {
    currency: core_1.CurrencySchema,
    orgName: core_1.NameSchema,
    orgRef: ruby_1.AppleProxyOrgRefSchema,
    parentOrgRef: ruby_1.AppleProxyOrgRefSchema,
    applePaymentModel: apple_proxy_web_1.AppleProxyPaymentModelSchema,
    orphaned: typebox_1.Type.Boolean({
        title: "Orphaned",
        description: "Do we have access to this organisation at present?",
    }),
    status: common_1.AppleOrganisationInfoStatusSchema,
};
exports.AppleOrganisationInfoSchema = (0, core_1.StrictObject)({
    ...AppleOrganisationInfoFields,
});
exports.AppleOrganisationInfoResponseSchema = (0, core_1.StrictObject)({
    ...AppleOrganisationInfoFields,
    authError: typebox_1.Type.Optional(typebox_1.Type.String()),
});
const AppleAuthResponseSchema = (0, core_1.StrictObject)({
    token: typebox_1.Type.Object(common_1.AppleAuthTokenFields),
    organisations: typebox_1.Type.Array(exports.AppleOrganisationInfoSchema),
    orphanedOrganisations: typebox_1.Type.Array(exports.AppleOrganisationInfoSchema),
}, {
    title: "Result of auth creation",
    description: "Includes the first bearer token and a list of the org ids that have been made available",
});
exports.CreateTeamAppleAuthResponseSchema = AppleAuthResponseSchema;
exports.CreateHostedAppleAuthResponseSchema = AppleAuthResponseSchema;
exports.ImportAppleAuthResponseSchema = AppleAuthResponseSchema;
exports.ListTeamOrganisationsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleOrganisationInfoResponseSchema);
/**
 * Body
 */
exports.CreateTeamAppleAuthBodySchema = (0, core_1.StrictObject)(CreateAppleAuthFields, {
    title: "Apple Auth creation request",
    description: "Request to store credentials for an Apple Search Ads account",
});
exports.CreateHostedAppleAuthBodySchema = (0, core_1.StrictObject)({
    ...CreateAppleAuthFields,
}, {
    title: "Apple Auth creation request",
    description: "Request to store credentials for an Apple Search Ads account",
});
exports.ImportAppleAuthBodySchema = (0, core_1.StrictObject)(ImportAppleAuthFields, {
    title: "Apple Auth Import request",
    description: "Request to store credentials for an Apple Search Ads account",
});
// Organisations
exports.ListTeamOrganisationsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
